import React, { useEffect, useState } from "react";
import {
  ReferenceInput,
  required,
  NumberInput,
  AutocompleteInput,
  useRecordContext
} from "react-admin";

import { useForm } from "react-final-form";
import { Grid } from "@material-ui/core";
import { FormTextField } from "../__common/FormTextField";

export const AutoCompleteIsolateCode = (props) => {
    const id_sample = props.id_sample;
    const form = useForm();
    const [reload, setReload] = useState(0);
    var sample='';
    var culture='';
    const record = useRecordContext();
    useEffect(() => {
        if(record.code){
            const splitedCode = record.code.split(".");
            if(splitedCode && splitedCode.length===3){
              form.change('isolate_number',splitedCode[2]);
            }
        }
     }, [])

    const autocompletar= async (value, position) => {
      const formData = form.getState().values;
      let isolateCode = formData.code ?? '';
      if(position!==3){
        if(value && position===2){
          const splitValue = value.split('.');
          if(splitValue.length > 1){
            value = splitValue[1];
          }
        }
        if(isolateCode){
          let codes = isolateCode.split('.');
          isolateCode = position===1?codes[1]:codes[0];
          sample = position===1?value:isolateCode;
          culture = position===1?isolateCode:value;
        }
        if((!isolateCode.includes(value)||!value)){
          form.change('code',`${sample}.${culture}.${formData.isolate_number ?? ''}`);
        }
      }
      else{
        const codes = isolateCode.split('.');
        if(codes && codes.length>2){
          form.change('code',`${codes[0]}.${codes[1]}.${formData.isolate_number ?? ''}`);
        }
      }
      setReload(p=>p+1);
    }
  
  
    return(
      <>
        <Grid item xs={12} sm={6} md={3}>
          <ReferenceInput
              {...{id:"sample"}}
              id="samples"
              label="Sample"
              source="id_sample"
              reference="samples"
              validate={required()}
              filter={{ id: id_sample }}
            >
              <AutocompleteInput
                {...{id:"sample"}}
                resettable={true}
                clearAlwaysVisible={true}
                optionText="code"
                //shouldRenderSuggestions={(value) => value.trim().length > 1}
                suggestionLimit={10}
                onUserAction = { (values, props)=> autocompletar(props.selectedItem ? props.selectedItem.code: '',1) }
              />
            </ReferenceInput>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
              <ReferenceInput
                label="Culture"
                source="id_culture"
                reference="cultures"
                validate={required()}
                filter={{ id_sample: id_sample }}
              >
                <AutocompleteInput
                  id="culture"
                  resettable={true}
                  clearAlwaysVisible={true}
                  optionText="code"
                  suggestionLimit={10}
                  onUserAction = { (values, props)=> autocompletar(props.selectedItem ? props.selectedItem.code: '',2) }
                />
              </ReferenceInput>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <NumberInput source="isolate_number" onChange={(e)=>autocompletar(e.target.value,3)} label="Isolate number" />
            </Grid>
            <Grid item xs={12} sm={6} md={3} alignItems={"flex-end"}>
              <div style={{fontSize:"0.7em", color:"gray"}}>Code culture</div>
              <FormTextField source="code" refresh={reload} ></FormTextField>
            </Grid>
            <br></br>
      </>
    )
  }
  